import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongkequanlydaotao from "components/Thongke/Quanlydaotao/Thongkequanlydaotao.js";
export default function TKquanlydaotao() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Thống kê quản lý đào tạo",
            tabContent: <Thongkequanlydaotao />,
          },
        ]}
      />
    </div>
  );
}
